import { AnalyticsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { matchPath } from "react-router-dom";
import { canSeeAnalyticsSection } from "../analytics-access";
import { defaultChildRoute } from "./legacy-redirects";

/** A single report lays out its own padding, like report pages in other sections. */
function hidePadding(url: string): boolean {
  return !!matchPath("/stores/:storeId/analytics/reports/custom/*", url);
}

export const analyticsRoutes: PermissionedRouteObject[] = [
  {
    path: "",
    handle: {
      breadcrumb: "Analytics",
      permission: ({ user, userPermissions }) =>
        canSeeAnalyticsSection(user.email) &&
        !!userPermissions?.has(AnalyticsPermissions.VIEW_ANALYTICS),
    },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page hidePadding={hidePadding} /> };
    },
    children: [
      defaultChildRoute("home"),
      {
        path: "home",
        handle: { breadcrumb: "Home" },
        async lazy() {
          const { AnalyticsHomePage } =
            // redont-allow-dynamic-import: route-level code splitting for carved analytics package
            await import("@redotech/redo-merchant-analytics-app/analytics/workspace/analytics-workspace-pages");
          return { Component: AnalyticsHomePage };
        },
      },
      {
        path: "reports",
        handle: { breadcrumb: "Reports" },
        children: [
          {
            index: true,
            async lazy() {
              const { AnalyticsCustomReportsTab } =
                // redont-allow-dynamic-import: route-level code splitting for carved analytics package
                await import("@redotech/redo-merchant-analytics-app/analytics/workspace/analytics-workspace-pages");
              return { Component: AnalyticsCustomReportsTab };
            },
          },
          {
            path: "custom/:customReportId",
            handle: { hideHeader: true },
            async lazy() {
              const { AnalyticsCustomReportPage } =
                // redont-allow-dynamic-import: route-level code splitting for carved analytics package
                await import("@redotech/redo-merchant-analytics-app/analytics/workspace/analytics-workspace-pages");
              return { Component: AnalyticsCustomReportPage };
            },
          },
        ],
      },
    ],
  },
];
